import React, { Component } from "react";

class PanelHeader extends Component {
  render() {
    return (
      <div
        style={{
          padding: '0px',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          paddingTop: '50px',
        }}
        className={
          "panel-header " +
          (this.props.size !== undefined ? "panel-header-" + this.props.size : "")
        }
      >
        <img
          alt=""
          style={{
            maxHeight: '200%',
            maxWidth: '200%',
            objectFit: 'contain'
          }}
          src={this.props.content}
        />
      </div>
    );
  }
}

export default PanelHeader;
